import { Injectable } from '@angular/core';
import { AccessoryFirstPageModel } from '../models/accessory-first-page.model';
import {
  NotificationProviderService,
  NotificationProviderTypeEnum
} from '../external-interfaces/notification-provider.service';
import SlotService from './slot.service';
import MessagesActionsService from '../utils/services/messages-actions.service';
import { DeviceMessage } from '../models/device.model';
import { IGlobalDevicesMessages } from '../interfaces/cart-details.interface';


@Injectable()
export default class AccessoriesService {
  public showSection = false;
  public accessoriesWithoutMessage: AccessoryFirstPageModel[] = [];
  public accessoriesWithMessage: AccessoryFirstPageModel[] = [];
  public unavailableAccessories: DeviceMessage[];

  constructor(
    private slotService: SlotService,
    private messagesActionsService: MessagesActionsService,
    private notificationProvider: NotificationProviderService,
  ) {
    this.notificationProvider.subscribe(
      NotificationProviderTypeEnum.CART_DETAILS,
      (cartDetails: any) => {
        if (!cartDetails) {
          return;
        }

        const list: any = this.slotService.getAccessories();
        this.showSection = !!list.length;

        this.unavailableAccessoriesMessages(cartDetails.globalDevicesMessages);
        this.filterAccessories(list);
      }
    );
  }

  public onHideMessage(event: Event, accessoryMessage: any): void {
    event.preventDefault();

    const accessoriesWithMessageIndex = this.accessoriesWithMessage.indexOf(accessoryMessage);
    const unavailableAccessoriesIndex = this.unavailableAccessories.indexOf(accessoryMessage);

    if (accessoriesWithMessageIndex !== -1) {
      this.accessoriesWithMessage[accessoriesWithMessageIndex].messages.isVisible = false;

      this.messagesActionsService.deleteMessage(accessoryMessage.messages.uid);
    }
    else if (unavailableAccessoriesIndex !== -1) {
      this.messagesActionsService.deleteMessage(accessoryMessage.uid, accessoryMessage.hash);

      this.unavailableAccessories.splice(unavailableAccessoriesIndex, 1);
    }
  }

  private filterAccessories(accessories: AccessoryFirstPageModel[]): void {
    this.accessoriesWithoutMessage = [];
    this.accessoriesWithMessage = [];

    accessories.forEach( (value: AccessoryFirstPageModel) => {
      const allMessages = value.messages.messages;

      if (allMessages && allMessages.length) {
        value.messages.message = allMessages.join(' ');
        value.messages.isVisible = true;

        this.accessoriesWithMessage.push(value);
      } else {
        this.accessoriesWithoutMessage.push(value);
      }
    });
  }

  private unavailableAccessoriesMessages(messages: IGlobalDevicesMessages): void {
    this.unavailableAccessories = [];

    if (messages && messages.messages) {
      messages.messages.forEach( (value: any) => {
        value.uid = messages['uid'];
        value.isVisible = value.isVisible || true;

        if (value.isVisible) {
          this.unavailableAccessories.push(value);
        }
      });
    }
  }
}
